module.exports = __webpack_public_path__ + "img/forgot-n1.6dc5774f.png";